import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminHero() {
  return (
    <AdminCrud
      title="Hero Slides"
      resource="hero-slides"
      defaultItem={{ title: "", subtitle: "", cta_label: "Explore", cta_link: "/packages", image_url: "", order: 1 }}
      fields={[
        { key: "title", label: "Title" },
        { key: "subtitle", label: "Subtitle", type: "textarea" },
        { key: "cta_label", label: "CTA Label" },
        { key: "cta_link", label: "CTA Link" },
        { key: "image_url", label: "Image", type: "image" },
        { key: "order", label: "Order", type: "number" },
      ]}
    />
  );
}
